import { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    CircularProgress,
    Alert,
    Box,
    Typography,
} from "@mui/material";

import { user_login_url } from "../api_registry";

export default function LoginDialog({ open, onClose, onLoginSuccess }) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleLogin = async () => {
        setLoading(true);
        setError("");

        try {
            const response = await fetch(user_login_url, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({ username, password }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(
                    data?.detail || data?.message || "Login failed",
                );
            }

            onLoginSuccess?.(data);
            onClose();
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={() => !loading && onClose()}
            maxWidth={false}
            slotProps={{
                paper: {
                    sx: {
                        width: 360,
                        borderRadius: 4,
                        overflow: "hidden",
                        backgroundColor: "white",
                        display: "flex",
                        flexDirection: "column",
                    },
                },
            }}
        >
            <DialogTitle
                sx={{
                    textAlign: "center",
                    fontWeight: 600,
                    background: "linear-gradient(90deg, #3b82f6, #8b5cf6)",
                    color: "white",
                    py: 2,
                    fontSize: "1.3rem",
                }}
            >
                Login
            </DialogTitle>

            <DialogContent
                sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    px: 3,
                    pb: 3,
                    gap: 3,
                    backgroundColor: "#fff",

                    "&.MuiDialogContent-root": {
                        paddingTop: "24px", // override built-in MUI padding
                    },
                }}
            >
                {error && <Alert severity="error">{error}</Alert>}

                <TextField
                    label="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    disabled={loading}
                    fullWidth
                />

                <TextField
                    label="Password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={loading}
                    fullWidth
                />
            </DialogContent>

            <DialogActions
                sx={{
                    px: 3,
                    pb: 3,
                    // justifyContent: "space-between",
                }}
            >
                <Button
                    variant="contained"
                    onClick={onClose}
                    disabled={loading}
                    sx={{
                        // minWidth: 120,
                        height: 40,
                        textTransform: "none",
                        background: "linear-gradient(135deg, #3b82f6, #f43311)",
                        fontWeight: 600,
                    }}
                >
                    Cancel
                </Button>

                <Button
                    variant="contained"
                    disabled={loading || !username || !password}
                    onClick={handleLogin}
                    sx={{
                        minWidth: 120,
                        height: 40,
                        textTransform: "none",
                        background: "linear-gradient(135deg, #3b82f6, #8b5cf6)",
                        fontWeight: 600,
                    }}
                >
                    {loading ? <CircularProgress size={22} /> : "Login"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
